
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aiAskResults",
      function () {
        return require("private-next-pages/aiAskResults.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aiAskResults"])
      });
    }
  